import { combineReducers } from "redux";

const defaultParams = {
  isSegmapListFetching: false,
  isSegmapListFetched: false,
  isCostCategoryFetching: false,
  isCostCategoryFetched: false,
  isCostCenterFetching: false,
  isCostCenterFetched: false,
};

function storeFetchedSegmapList(state = [], action) {
  if (action.type === "STORE_FETCHED_SEGMAP_LIST") {
    return action.payload;
  }
  return state;
}

function storeFetchedCompanyList(state = [], action) {
  if (action.type === "STORE_FETCHED_COMPANY_LIST") {
    return action.payload;
  }
  return state;
}

function storeFetchedCostCategory(state = [], action) {
  if (action.type === "STORE_FETCHED_COST_CATEGORY") {
    return action.payload;
  }
  return state;
}

function storeFetchedCostCenter(state = [], action) {
  if (action.type === "STORE_FETCHED_COST_CENTER") {
    return action.payload;
  }
  return state;
}

function params(state = defaultParams, action) {
  switch (action.type) {
    case "FETCH_SEGMAP_LIST":
      return {
        ...state,
        isSegmapListFetching: true,
        isSegmapListFetched: false,
      };

    case "STORE_FETCHED_SEGMAP_LIST":
      return {
        ...state,
        isSegmapListFetching: false,
        isSegmapListFetched: true,
      };

    case "FETCH_SEGMAP_LIST_FAILURE":
      return {
        ...state,
        isSegmapListFetching: false,
        isSegmapListFetched: false,
      };

    case "FETCH_COST_CATEGORY":
      return {
        ...state,
        isCostCategoryFetching: true,
        isCostCategoryFetched: false,
      };

    case "STORE_FETCHED_COST_CATEGORY":
      return {
        ...state,
        isCostCategoryFetching: false,
        isCostCategoryFetched: true,
      };

    case "FETCH_COST_CATEGORY_FAILURE":
      return {
        ...state,
        isCostCategoryFetching: false,
        isCostCategoryFetched: false,
      };

    case "FETCH_COST_CENTER":
      return {
        ...state,
        isCostCenterFetching: true,
        isCostCenterFetched: false,
      };

    case "STORE_FETCHED_COST_CENTER":
      return {
        ...state,
        isCostCenterFetching: false,
        isCostCenterFetched: true,
      };

    case "FETCH_COST_CENTER_FAILURE":
      return {
        ...state,
        isCostCenterFetching: false,
        isCostCenterFetched: false,
      };

    case "RESET_DATA":
      return defaultParams;

    default:
      return state;
  }
}

function alertModalState(state = {}, action) {
  if (action.type === "SET_ALERT_MODAL_STATE") {
    return action.payload;
  }
  return state;
}

const commonReducers = combineReducers({
  params,
  storeFetchedSegmapList,
  storeFetchedCompanyList,
  storeFetchedCostCategory,
  storeFetchedCostCenter,
  alertModalState,
});

export default commonReducers;
